import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { BenefitListComponent } from './benefit-list/benefit-list.component'

export const benefitRoutes: Route[] = [
  {
    path: 'benefits',
    component: BenefitListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'benefits/:id/edit',
    redirectTo: 'benefits/:id',
    pathMatch: 'full'
  },
  {
    path: 'benefits/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'Benefit',
        nameSingular: 'Benefit',
        namePlural: 'Benefits',
        path: 'benefits',
        slug: 'taxonomies/benefits',
        title: 'Benefits'
      }),
      permission: 'readTaxonomies'
    }
  }
]
